<template>
  <DoorIcon v-if="showIcon"
    :disabled="disabled"
    :parent-disconnected="gatewayOrDeviceNotConnected"
    :state="state"
    :alarm="alarm"
    :hasMonitor="hasDoorMonitor"
  />
  <span v-else-if="showLabel">
    {{ label }}
  </span>
</template>

<script lang="ts">
import { qx_eDeviceConnectionStatus_enum, qx_eDoorMonitor_enum } from '@/graphql/types';
import { smartIconValidator } from './helpers/smart-icon-validator';
import { getDoorStatusIcon } from '@/constants/door';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    door: {
      type: Object,
      required: true
    },
    type: {
      required: false,
      default: "icon",
      validator(value: string) {
        return smartIconValidator(value);
      }
    }
  },
  computed: {
    disabled() {
      return !this.door?.enabled || this.door.disabledByLicense;
    },
    state() {
      return this.door?.state || undefined;
    },
    alarm() {
      return this.door?.alarm || undefined;
    },
    hasDoorMonitor() {
      const isAperioWithAddress = this.door?.type === 'wireless' && !!this.door?.doorMonitorAddress;
      const isNotNullMonitor = this.door?.doorMonitor != qx_eDoorMonitor_enum.None;
      return isNotNullMonitor || isAperioWithAddress;
    },
    label() {
      const { alarm, state, gatewayOrDeviceNotConnected, hasDoorMonitor, disabled } = this;
      const status = getDoorStatusIcon(alarm, state, gatewayOrDeviceNotConnected, this.door.disabledByLicense, hasDoorMonitor, !disabled);
      return status?.tooltip || '';
    },
    gatewayOrDeviceNotConnected() {
      const fullyConnected = this.door?.gatewayConnectionStatus && this.door.deviceConnectionStatus === qx_eDeviceConnectionStatus_enum.Connected;
      return !(fullyConnected || false);
    },
    showIcon() {
      return this.type === "icon";
    },
    showLabel() {
      return this.type === "label";
    }
  }
});
</script>
